import { createRouter, createWebHistory } from 'vue-router'

import Month from '../components/CalendarMonth'
import NotFound from '../components/HelloWorld'


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Month
    },
    {
      path: '/co/:calendaronly',
      name: 'HomeCalendarOnly',
      component: Month,
      props : true
    },{
      path: '/:layer/',
      name: 'HomeWithLayer',
      component: Month,
      props : true
    },
    {
      path: '/:layer/co/:calendaronly',
      name: 'HomeWithLayer',
      component: Month,
      props : true
    },
    {
      path: '/api',
      name: 'API',
      redirect: './api'   
    },
    {
      path: '/swagger',
      name: 'SWAGGER',
      redirect: './swagger'   
    },
    {
      path: '/year/:year/month/:month',
      name: 'Month',
      component: Month,
      props : true
    },
    {
      path: '/:layer/year/:year/month/:month',
      name: 'MonthByLayer',
      component: Month,
      props : true
    },
    {
      path: '/year/:year/month/:month/co/:calendaronly',
      name: 'MonthCalendarOnly',
      component: Month,
      props : true
    },
    {
      path: '/:layer/year/:year/month/:month/co/:calendaronly',
      name: 'MonthByLayerCalendarOnly',
      component: Month,
      props : true
    },
    {
      path: '/:catchAll(.*)',
      name: 'NotFound',
      component: NotFound
    }
  ]
})

export default router